// Animation utilities for the Wonder Navigation components
import { keyframes } from '@emotion/react';

// Pulse animation for loading indicators
export const pulseAnimation = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(0.98);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.98);
  }
`;

// Spinner animation for loading indicators
export const spinnerAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Fade in animation
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Slide down animation for dropdown menus
export const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Shimmer animation for loading states
export const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// Magnificent slide in from right animation for sidebar
export const slideInRight = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
    box-shadow: 0 0 0 rgba(139, 92, 246, 0);
  }
  20% {
    opacity: 1;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
    box-shadow: -10px 0 30px rgba(139, 92, 246, 0.3);
  }
`;

// Magnificent slide out to right animation for sidebar
export const slideOutRight = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
    box-shadow: -10px 0 30px rgba(139, 92, 246, 0.3);
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
    box-shadow: 0 0 0 rgba(139, 92, 246, 0);
  }
`;

// Backdrop fade in animation
export const backdropFadeIn = keyframes`
  0% {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  100% {
    opacity: 1;
    backdrop-filter: blur(5px);
  }
`;

// Backdrop fade out animation
export const backdropFadeOut = keyframes`
  0% {
    opacity: 1;
    backdrop-filter: blur(5px);
  }
  100% {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
`;

// Content fade in animation with scale
export const contentFadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

// Loading indicator component styles
export const loadingIndicatorStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  },
  spinner: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '3px solid rgba(255, 255, 255, 0.1)',
    borderTopColor: '#8b5cf6', // Purple
    animation: `${spinnerAnimation} 1s infinite linear`,
  },
  pulse: {
    animation: `${pulseAnimation} 1.5s infinite ease-in-out`,
  },
  shimmer: {
    backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(139,92,246,0.2) 50%, rgba(255,255,255,0) 100%)',
    backgroundSize: '200% 100%',
    animation: `${shimmer} 1.5s infinite`,
  }
};